import type { ShadowLocation } from "../../types/location-map";

export type LocationSetupGap = "installation" | "sensors" | "zone";

const SETUP_GAP_LABELS: Record<LocationSetupGap, string> = {
	installation: "Installation",
	sensors: "Sensors",
	zone: "Zone",
};

/** What’s still needed before a location is fully set up for mapping. */
export const getLocationSetupGaps = (
	location: ShadowLocation,
	hasInstallation: boolean,
): LocationSetupGap[] => {
	const gaps: LocationSetupGap[] = [];
	if (!hasInstallation) gaps.push("installation");

	const zones = location.zones ?? [];
	if (zones.length === 0) gaps.push("zone");

	const hasSensors = zones.some(
		(zone) =>
			(zone.sensors?.length ?? 0) > 0 || (zone.sensorIds?.length ?? 0) > 0,
	);
	if (!hasSensors) gaps.push("sensors");

	return gaps;
};

/** Tooltip copy, e.g. `Missing: Installation, Zone`. */
export const formatLocationSetupGapsTooltip = (
	gaps: readonly LocationSetupGap[],
): string => {
	if (gaps.length === 0) return "";
	return `Missing: ${gaps.map((gap) => SETUP_GAP_LABELS[gap]).join(", ")}`;
};

/** True when installation and/or zone are still missing (sensors cannot be added yet). */
export const hasStructuralSetupGaps = (
	gaps: readonly LocationSetupGap[],
): boolean => gaps.some((gap) => gap === "installation" || gap === "zone");
